<div class="modal-main" [formGroup]="formGroup">
  <ng-container *ngIf="stepper === 1">
    <app-device-details
      formGroupName="deviceDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [parentType]="parentType"
      [deviceType]="deviceType"
      [activationState]="activationState"
      [batteryPercentage]="batteryPercentage"
    >
    </app-device-details>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-update-device-name
      formGroupName="deviceDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-update-device-name>
  </ng-container>

  <ng-container *ngIf="stepper === 3">
    <app-change-device-type
      formGroupName="deviceDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [parentType]="parentType"
      [deviceType]="deviceType"
      (updateDeviceInfoSyc)="updateDeviceInfoSyc($event)"
    >
    </app-change-device-type>
  </ng-container>

  <ng-container *ngIf="stepper === 5">
    <app-device-users
      [userList]="userList"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
    </app-device-users>
  </ng-container>

  <ng-container *ngIf="stepper === 6">
    <app-device-info
      formGroupName="deviceInfo"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [parentType]="parentType"
      [deviceType]="deviceType"
    >
    </app-device-info>
  </ng-container>

  <ng-container *ngIf="stepper === 7">
    <app-change-door-mode
      formGroupName="deviceDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [parentType]="parentType"
      [deviceType]="deviceType"
    >
    </app-change-door-mode>
  </ng-container>
</div>
